import { clsx } from 'clsx';
import { ReactNode } from 'react';

export const Wrapper = ({
  hatchPattern,
  hatchClasses,
  isValidated,
  children,
}: {
  isValidated?: boolean;
  hatchPattern: string;
  hatchClasses: string;
  children: ReactNode;
}) =>
  typeof isValidated === 'boolean' ? (
    <div className="flex h-full flex-1">
      <div className={clsx('w-2 shrink-0 mr-1', hatchPattern, hatchClasses)} />
      {children}
    </div>
  ) : (
    <>{children}</>
  );
